<template>
  <div v-show="isActive" id="purchase_confirm" class="popup-frame" :class="{ active: isActive }">
    <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
      <div class="popup-package iframe-full-screen">
        <button class="btn-close" @click="hideModel" />
        <div class="popup-content">
          <div class="popup-header" />
          <div class="popup-body" style="width: 100%; height: calc(100dvh - 230px);">
            <!-- vip_birthday, vip_weekly, vip_monthly, rebate -->
            <template v-if="selectedProd && selectedProd.type === 1">
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.type_name_title_6') }}：
                    <span class="exchange-t2">{{ selectedProd.name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_7') }}：
                    <span class="exchange-t3">{{ selectedProd.reward | numberFormat }}{{ $t('Bao.point_unit_2') }}</span>
                  </div>
                  <div class="title">
                    進呈先：
                    <span class="exchange-t2">BONUSウォレット</span>
                  </div>
                  <div class="title">
                    賭け条件：
                    <span class="exchange-t2">ボーナス額の25倍</span>
                  </div>
                  <div class="title">
                    **禁止ゲーム：
                    <span class="exchange-t2">**パチンコ・パチスロ、クラッシュ、ブラックジャック、ルーレット、Evolution社の「ファーストパーソン」シリーズ</span>
                  </div>
                  <div class="title">
                    ベット額上限：
                    <span class="exchange-t2">
                      ※スロット：一回 625JPY / 5 USD（Bonus Buyの場合、購入総額をベット額とみなす）
                      ※ライブカジノ：一回 3,000JPY / 20 USD
                    </span>
                  </div>
                  <div class="title">
                    **出金上限：
                    <span class="exchange-t2">
                      **なし
                    </span>
                  </div>
                  <div class="title">
                    注意事項などの詳細については、該当プロモーションページにてご確認ください。
                  </div>
                </div>
              </div>
            </template>
            <!-- vip_upgrade -->
            <template v-if="selectedProd && selectedProd.type === 2">
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.type_name_title_6') }}：
                    <span class="exchange-t2">{{ selectedProd.type_name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_7') }}：
                    <span class="exchange-t3">{{ selectedProd.upgrade_prize | numberFormat }}{{ $t('Bao.point_unit_2') }}</span>
                  </div>
                  <div class="title">
                    進呈先：
                    <span class="exchange-t2">BONUSウォレット</span>
                  </div>
                  <div class="title">
                    賭け条件：
                    <span class="exchange-t2">ボーナス額の25倍</span>
                  </div>
                  <div class="title">
                    **禁止ゲーム：
                    <span class="exchange-t2">**パチンコ・パチスロ、クラッシュ、ブラックジャック、ルーレット、Evolution社の「ファーストパーソン」シリーズ</span>
                  </div>
                  <div class="title">
                    ベット額上限：
                    <span class="exchange-t2">
                      ※スロット：一回 625JPY / 5 USD（Bonus Buyの場合、購入総額をベット額とみなす）
                      ※ライブカジノ：一回 3,000JPY / 20 USD
                    </span>
                  </div>
                  <div class="title">
                    **出金上限：
                    <span class="exchange-t2">
                      **なし
                    </span>
                  </div>
                  <div class="title">
                    注意事項などの詳細については、該当プロモーションページにてご確認ください。
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="popup-footer my-mall-popup-ft-frame">
            <div class="mall-exchange-footer">
              <button
                type="button"
                class="btn btn-ptimary btn-style-outline-secondary btn-exchange"
                @click="confirmPurchase"
              >
                {{ $t('Bao.redeem') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
    selectedProd: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  methods: {
    hideModel() {
      this.$emit('hideModel')
    },
    confirmPurchase() {
      this.$store.commit('SET_SHOP_PURCHASE', true)
      this.$emit('hideModel')
    },
    formatDate(timestamp) {
      const date = new Date((timestamp + 73 * 3600) * 1000)
      // 有效時間,因為我們是＋8的時區～但日本是＋9, 得用created_at的時間＋73小時

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    }
  }
}
</script>
